import { Component, ChangeDetectionStrategy, Input } from '@angular/core'

const THUMBNAIL_QUALITY = 60
const IMG_WIDTH = 91
const THUMBNAIL_SCALE = 2

// Using the exact element width causes resizing artifacts in the jpeg.
// We scale up to make images more clear.
const THUMBNAIL_WIDTH = IMG_WIDTH * THUMBNAIL_SCALE

@Component({
  selector: 'flo-content-small',
  templateUrl: './content-small.component.html',
  styleUrls: ['./content-small.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentSmallComponent {
  private _imgUrl: string

  @Input() public title: string
  @Input() public publishDate: Date | null = null
  @Input() public overlayCaption?: string = undefined

  @Input() public set imgUrl(url: string) {
    this._imgUrl = url + `?width=${THUMBNAIL_WIDTH}&quality=${THUMBNAIL_QUALITY}`
  }
  public get imgUrl(): string {
    return this._imgUrl
  }

  public imgLoadError = false
}
